<ng-template vdrDialogTitle>Archive Store Site</ng-template>

<div class="modal-body">
    <div class="warning-message">
        <clr-icon shape="exclamation-triangle" class="warning-icon"></clr-icon>
        <p class="warning-text">
            You are about to permanently archive <strong>"{{ storeName }}"</strong>.
        </p>
    </div>


    <div class="consequences-section">
        <p class="section-label">I understand that:</p>
        <ul class="consequences-list">
            <li>
                <clr-icon shape="times-circle" class="consequence-icon"></clr-icon>
                The site will be taken offline and become inaccessible to visitors
            </li>
            <li>
                <clr-icon shape="times-circle" class="consequence-icon"></clr-icon>
                All account members will lose admin access to this site
            </li>
            <li>
                <clr-icon shape="times-circle" class="consequence-icon"></clr-icon>
                The subdomain <strong>{{storeSite?.identifier}}.dealomega.com</strong> will remain reserved
            </li>
        </ul>
    </div>

    <div class="confirmation-section" *ngIf="!hasActiveSubscription">
        <label for="confirmation-input" class="confirmation-label">
            Confirm by typing <strong>{{storeSite?.identifier}}</strong> below.
        </label>
        <input 
            id="confirmation-input"
            type="text" 
            class="clr-input confirmation-input"
            [formControl]="confirmationControl"
            placeholder="Enter store identifier"
        />
    </div>

    <div class="final-warning" *ngIf="!hasActiveSubscription">
        <clr-icon shape="warning-standard" class="alert-icon"></clr-icon>
        <strong>This action cannot be undone.</strong> Are you sure you want to continue?
    </div>
</div>


<div class="subscription-warning" *ngIf="hasActiveSubscription">
    <clr-icon shape="info-circle" class="info-icon"></clr-icon>
    <div class="subscription-warning-text">
        <strong>Active Subscription Detected</strong>
        <p>This store site has an active subscription plan. You must cancel the subscription before proceeding with the archive operation.</p>
    </div>
</div>

<ng-template vdrDialogButtons>
    <button type="button" class="btn btn-secondary" (click)="cancel()">
        Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="confirm()" [disabled]="!isConfirmationValid">
        Yes, archive this store site
    </button>
</ng-template>

